import { render, staticRenderFns } from "./POEM.vue?vue&type=template&id=4f20365a&"
import script from "./POEM.vue?vue&type=script&lang=js&"
export * from "./POEM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports